export default new class BookFormat {
	init() {
		this.initBookFormat();
	}

	initBookFormat() {
		document.querySelectorAll('#formats article').forEach(article => {
			article.addEventListener('click', () => {
				const formatId = article.dataset.format;
				document.querySelectorAll('#formats article').forEach(article => {
					article.classList.remove('border-2', 'border-yellow');
					article.classList.add('border');
				});
				article.classList.add('border-2', 'border-yellow');

				document.querySelectorAll('#retailers > div').forEach(retailer => {
					if(retailer.dataset.format == formatId) {
						retailer.classList.remove('hidden');
					} else {
						retailer.classList.add('hidden');
					}
				});
			})
		});
	}
}